import styles from './CustomerAccountSelectModal.module.scss'
import './CustomerAccountSelectModal.scss'

import { Backdrop, Modal } from '@material-ui/core'
import clsx from 'clsx'

import { FastQuoteInput } from '../../../../GlobalComponents/Inputs/Inputs'
import { FilterIcon } from '../../../../GlobalComponents/_icons/Icons'

import { useAppSelector, useAppDispatch } from '../../../../app/hooks'

import {
    LOADING_STATES,
    PACustomerContactViewRow,
    selectFilteredAccounts,
    selectCustomer,
    setCurrentSearch,
    setCustomersLoading,
    setAccountFilter,
} from '../../../../features/customer/customerSlice'

import CustomerAccountSelect from '../../../../FastQuote/Components/CustomerAccountSelect'
import { closeModals, MODALS } from '../../../../features/meta/metaSlice'
import IdentifierModal from '../../../../FastQuote/Components/IdentifierModal'
import { CustomerTypeModal } from '../../../../FastQuote/Components/CustomerTypeModal'
import { UniqueCustomerNameModal } from '../../../../FastQuote/Components/UniqueCustomerNameModal'

interface CustomerAccountSelectModalProps {
    close(): void
    open: boolean
}

const CustomerAccountSelectModal = (props: CustomerAccountSelectModalProps) => {
    const { close, open } = props

    const dispatch = useAppDispatch()
    const modal = useAppSelector((state) => state.meta.currentModal)

    const customersLoading = useAppSelector((state) => state.customer.customersLoading)
    const accountFilter = useAppSelector((state) => state.customer.currentFilter)
    const startedCustomerSearch = useAppSelector((state) => state.customer.startedCustomerSearch)

    const loading = customersLoading === LOADING_STATES.LOADING

    const renderModal = (modal: MODALS, props: any) => {
        if (modal === MODALS.UPDATE) return <IdentifierModal {...props} />
        else if (modal === MODALS.CUSTOMER_TYPE) return <CustomerTypeModal {...props} />
        else if (modal === MODALS.UNIQUE_CUSTOMER_NAME)
            return <UniqueCustomerNameModal {...props} />
    }

    return (
        <Modal
            open={open}
            className={styles.modal}
            onClose={close}
            aria-labelledby='simple-modal-title'
            aria-describedby='simple-modal-description'
            BackdropComponent={Backdrop}
        >
            <div className={`${styles.customerAccountSelectModal} customerAccountSelectModal`}>
                <div className={styles.customerAccountSelectTitleBar}>
                    <div style={{ display: 'inline-block', width: 350 }}>
                        Select Customer Account Code
                    </div>
                    <div
                        style={{ display: 'inline-block', float: 'right' }}
                        className='a-i-close'
                        onClick={close}
                    />
                </div>
                <div className={'a-divider'} />
                <div>
                    <div className={clsx([styles.container, styles.searchContainer])}>
                        {loading && (
                            <div className={'centered'}>
                                <div
                                    className={'k-i-loading'}
                                    style={{ fontSize: 200, height: 580 }}
                                />
                            </div>
                        )}
                        {!loading && (
                            <>
                                <div className={clsx([styles.container, styles.accountFilter])}>
                                    {startedCustomerSearch && (
                                        <FastQuoteInput
                                            Icon={FilterIcon}
                                            value={accountFilter}
                                            onChange={(value: string) =>
                                                dispatch(setAccountFilter(value))
                                            }
                                            placeholder={'Filter Search Results'}
                                            renderEndIcon={() => (
                                                <div
                                                    style={{
                                                        width: 18,
                                                        height: 15,
                                                        visibility: accountFilter
                                                            ? 'visible'
                                                            : 'hidden',
                                                    }}
                                                    className={'a-i-close'}
                                                    onClick={() => {
                                                        dispatch(setAccountFilter(''))
                                                    }}
                                                />
                                            )}
                                        />
                                    )}
                                </div>
                                <CustomerAccountSelect
                                    onCustomerSelect={(customer: PACustomerContactViewRow) => {
                                        dispatch(selectCustomer(customer))
                                        dispatch(setCurrentSearch(customer.AccountCode.trim()))
                                        dispatch(setCustomersLoading(LOADING_STATES.INIT))
                                        close()
                                    }}
                                />
                            </>
                        )}
                    </div>
                </div>
                <Modal
                    open={modal !== MODALS.NONE}
                    className={styles.modal}
                    onClose={() => {
                        dispatch(closeModals())
                    }}
                    aria-labelledby='simple-modal-title'
                    aria-describedby='simple-modal-description'
                    BackdropComponent={Backdrop}
                >
                    <div className={styles.modalContainer}>
                        {renderModal(modal, {
                            close: () => {
                                dispatch(closeModals())
                            },
                        })}
                    </div>
                </Modal>
            </div>
        </Modal>
    )
}

export default CustomerAccountSelectModal
